// BMC header: ink background after scrolling, full-screen mobile menu, smooth in-page section links, cart count visibility.
(() => {
  const header = document.querySelector('[data-bmc-header]');
  if (!header) return;
  const menu = header.querySelector('#bmc-menu');
  const openBtn = header.querySelector('[data-bmc-menu-open]');

  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  openBtn.addEventListener('click', () => {
    menu.showModal();
    openBtn.setAttribute('aria-expanded', 'true');
  });
  header.querySelector('[data-bmc-menu-close]').addEventListener('click', () => menu.close());
  menu.addEventListener('close', () => openBtn.setAttribute('aria-expanded', 'false'));

  // Links like "/#shows" (header and footer): if that section is on this page, scroll to it instead of reloading.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-bmc-nav]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    const target = url.hash && document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    if (menu.open) menu.close();
    target.scrollIntoView();
    history.pushState(null, '', url.hash);
  });

  // Ella rewrites [data-cart-count] after cart changes; hide the bubble when it reads 0.
  header.querySelectorAll('[data-cart-count]').forEach((count) => {
    const sync = () => { count.hidden = count.textContent.trim() === '0'; };
    new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
  });
})();
